import { styled } from '@mui/material/styles';

const DividerDiv = styled('div')({
  borderTop: '1px solid #d3d3d3',
});

export const Divider = () => {
  return <DividerDiv data-testid="divider" />;
};
